<template>
  <div class="full-color" :class="direction">
    <span class="bg-yellow-ml"></span>
    <span class="bg-orange-ml"></span>
    <span class="bg-red-ml"></span>
    <span class="bg-rose-ml"></span>
    <span class="bg-purple-ml"></span>
    <span class="bg-deep-purple-ml"></span>
    <span class="bg-wl-primary"></span>
    <span class="bg-cyan-ml"></span>
    <span class="bg-light-green-ml"></span>
    <span class="bg-green-ml"></span>
  </div>
</template>

<script>
export default {
  name: 'FullColor',

  props: {
    direction: {
      default: 'horizontal',
    },
  },
};
</script>

<style scoped lang="scss">
.full-color {
  display: flex;
  justify-content: space-between;

  &.horizontal {
    width: 100%;
    span {
      height: 0.3rem;
    }
  }

  &.vertical {
    height: 100%;
    flex-direction: column;
    span {
      width: 0.4rem;
    }
  }

  span {
    flex-grow: 1;
  }
}
</style>
